import { CSSProperties, FC, ReactNode } from 'react';
import { Button, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { Box } from '../Box';
import { Center } from '../Center';
import { Column } from '../Column';

interface IProps {
  Icon: FC;
  title: string;
  description: string | ReactNode;
  width?: number | string;
  buttonText?: string;
  onButtonClick?: () => void;
  descriptionStyle?: CSSProperties;
  style?: CSSProperties;
}

export const EmptyScreen = ({
  Icon,
  title,
  description,
  width = 405,
  buttonText,
  onButtonClick,
  descriptionStyle = {},
  style = {},
}: IProps) => (
  <Center>
    <Box
      style={{
        marginTop: 60,
        marginBottom: 28,
        ...style,
      }}
    >
      <Icon />
    </Box>
    <Column width={width} gap={8}>
      <Typography as="span" size="heading_4" bold color={colors.neutral[500]} textAlign="center">
        {title}
      </Typography>
      <Typography as="span" color={colors.neutral[500]} textAlign="center" style={descriptionStyle}>
        {description}
      </Typography>
    </Column>
    {buttonText && onButtonClick && (
      <Button onClick={onButtonClick} size="lg" style={{ marginTop: 60 }}>
        {buttonText}
      </Button>
    )}
  </Center>
);
